<template>
   <div>
      <picture v-show="config.type === 'img' || 'image'">
         <source :srcset="config.src + '?fm=webp'" type="image/webp" />
         <source :srcset="config.src" type="image/png" />
         <img
            v-lazy-image
            :data-src="config.src"
            src="/public/images/rect_swipper.svg"
            :height="config.height"
            :width="config.width"
            :alt="config.alt"
            :class="config.class + ' swiper-lazy'"
         />
      </picture>
      <div class="swiper-lazy-preloader" />
   </div>
</template>

<script>
export default {
   name: 'ImageContainer',
   props: {
      config: {
         type: Object,
         default: () => ({
            container: 'img',
            height: '100px',
            width: '100px',
            src: '',
            class: '',
            alt: '',
         }),
      },
   },
};
</script>
